import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";

import Swal from "sweetalert2";

import {
  Comment,
  User,
  Discussion,
  PanelMember,
} from "../../../../../../models";
import { CommentService } from "../../../../../../services";

@Component({
  selector: "parent-comment",
  templateUrl: "./parent-comment.component.html",
  styleUrls: [
    "./parent-comment.component.scss",
    "../../../../../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ParentCommentComponent implements OnInit {
  public defaultUserImg: string =
    "../../../../../../../../assets/images/uMuzi/african-mask.png";
  public canModifyComment: boolean;
  public isHost: boolean;

  @Input() currentUser: User;
  @Input() currentPanelMember: PanelMember;
  @Input() discussion: Discussion;
  @Input() comment: Comment;
  @Output() updateAsLoading = new EventEmitter<any>();

  constructor(private commentService: CommentService) {}

  ngOnInit() {
    this.canModifyComment =
      this.currentUser.username === this.comment.author.username;

    this.isHost =
      this.discussion.author.username === this.comment.author.username;
  }

  public updateSectionAsLoading(status) {
    this.updateAsLoading.emit(status);
  }

  public deleteComment() {
    this.updateAsLoading.emit(true);

    this.commentService.deleteOne(this.discussion, this.comment).subscribe(
      () => {
        this.updateAsLoading.emit(false);
        this.fireSuccessAlert();
      },
      (errors) => {
        this.fireErrorAlert();
      }
    );
  }

  public openCommentDeleteConfirmation() {
    Swal.fire({
      title: "Delete comment?",
      text: "sure you want to delete this comment?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, delete!",
    }).then((result) => {
      if (result.value) {
        this.deleteComment();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire({
      title: "Deleted!",
      text: "Your Comment has been deleted",
      type: "success",
    }).then(function () {
      window.location.reload();
    });
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your submission.", "warning");

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }

  public onToggleUpvote(upvoted: boolean) {
    this.comment.voted.upVote = upvoted;

    if (this.comment.voted.downVote && this.comment.voted.upVote) {
      this.onToggleDownvote(false);
    }

    if (upvoted) {
      this.comment.upVoteCount++;
    } else {
      this.comment.upVoteCount--;
    }
  }

  public onToggleDownvote(downvoted: boolean) {
    this.comment.voted.downVote = downvoted;

    if (this.comment.voted.downVote && this.comment.voted.upVote) {
      this.onToggleUpvote(false);
    }

    if (downvoted) {
      this.comment.downVoteCount++;
    } else {
      this.comment.downVoteCount--;
    }
  }
}
